import SkeletonLoader from "../SkeletonLoader"

const PaginationSkeleton = () => {
  return (
    <div className="bg-white rounded-lg border-solid border-[1px] border-gray-200 flex flex-wrap items-center min-w-[320px] !box-border justify-between px-[16px] py-[18px] mt-2">
      <SkeletonLoader width={80} height={20} />
      <div className={`flex items-center space-x-1`}>
        <SkeletonLoader width={260} height={32} />
      </div>
    </div>
  )
}

export default PaginationSkeleton
